<template>
  <div class="bom-detail-row bom-detail-head">
    <div
      v-for="(label, index) in headings" :key="index" v-overflow-tooltip>
      {{ label }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    headings: { type: Array, required: true }
  }
}
</script>
